import * as React from 'react';
import parse from 'html-react-parser';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Text } from '../../../../../../../components';
import { InteractiveButton } from '../../../../../components';
import iconCancel from '../../../../../../../../assets/illustrations/cancel-procedure.svg';
import IDHelpers from '../../../../../../../../core/helpers/IDHelper';

const BlockCommon = styled.div.attrs((props: any) => ({
  gotoPayment: props.gotoPayment
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;

  .ok__text {
    align-self: center;
    width: 100%;
  }

  .ok__textv2 {
    align-self: center;
    width: 100%;
  }

  @media (min-width: 640px) {
    flex-direction: row;

    .ok__text {
      align-self: flex-start;
      width: 99px;
    }

    .ok__textv2 {
      align-self: flex-start;
      width: ${(props) => (props.gotoPayment ? '132px' : '99px')};
    }
  }
`;

interface ConfirmActionProps {
  handleClickConfirm: () => void;
  handleClickCancel: () => void;
  activatePayment: boolean;
  gotoPayment: boolean;
  anulate: boolean;
  amount: string;
  deliveryMode?: any;
  amountDelivery?: any;
}
const ConfirmAction: React.FC<ConfirmActionProps> = (props) => {
  const {
    handleClickConfirm,
    handleClickCancel,
    activatePayment,
    gotoPayment,
    anulate,
    amount,
    deliveryMode,
    amountDelivery
  } = props;
  let title = '';
  let subtitle = '';
  let okText = '';
  let cancelText = '';

  if (activatePayment) {
    title = '¿Estás seguro de activar|el pago?';
    subtitle = `Al aceptar, se cargará el monto|de <b>S/ ${amount}.00</b>  ${
      deliveryMode === 'D'
        ? `por carné universitario y <br/> <strong> S/ ${amountDelivery}.00</strong> por delivery a tus pagos pendientes.`
        : 'a tus pagos pendientes.'
    }`;
    okText = 'Sí, actívalo';
    cancelText = 'Cancelar';
  }
  if (gotoPayment) {
    title = '¡Listo!|Se ha creado el pago';
    subtitle = `${
      deliveryMode !== ''
        ? 'Ya se encuentra disponible tu pago. Recuerda que una vez realizado el pago podrás recoger tu carné universitario.'
        : 'Ya se encuentra disponible tu pago.|Recuerda que una vez realizado el pago|podrás descargar tu Constancia.'
    }`;
    okText = 'Ir a pagos';
    cancelText = 'Lo haré después';
  }
  if (anulate) {
    title = '¿Deseas anular este trámite?';
    subtitle =
      'Al aceptar esta acción, recuerda que tendrás que volver a solicitarlo.';
    okText = 'Sí, anular';
    cancelText = 'Cancelar';
  }

  return (
    <Block
      customized
      maxWidth={isMobile ? '100%' : '496px'}
      backgroundColor="#fff"
      padding="0px 32px 32px 32px"
      margin="8px 0px 0px 0px"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      {anulate && (
        <Block
          customized
          display="flex"
          justifyContent="center"
          alignItems="center"
          margin="0px 0px 16px"
        >
          <img src={iconCancel} alt="error" />
        </Block>
      )}
      {title.split('|').map((t) => (
        <Heading
          key={IDHelpers.generateID()}
          text={t}
          level={2}
          color="#161D1F"
          size={20}
          lineHeight={32}
          fontWeight="900"
          className=""
          align="center"
          width="100%"
        />
      ))}
      <Block
        customized
        margin="16px 0px 40px 0px"
        justifyContent="center"
        alignItems="center"
      >
        {subtitle.split('|').map((t) => {
          const titleSafe = parse(t || '');
          return (
            <Text
              key={IDHelpers.generateID()}
              textAlign="center"
              fontWeight="400"
              fontSize="14px"
              lineHeight="20px"
            >
              {titleSafe}
            </Text>
          );
        })}
      </Block>

      <BlockCommon gotoPayment={gotoPayment}>
        <div className="ok__text">
          <InteractiveButton
            bkgColorEnabled="#5B36F2"
            bkgColorHover="#745EF6"
            bkgColorFocus="#4318CD"
            bkgColorPressed="#4318CD"
            customized
            alignItems="center"
            backgroundColor="#5B36F2"
            padding="10px 0px"
            borderRadius="4px"
            width="100%"
            onClick={handleClickConfirm}
          >
            <Text
              color="#FFFFFF"
              fontSize="14px"
              lineHeight="20px"
              fontWeight="700"
              textAlign="center"
            >
              {okText}
            </Text>
          </InteractiveButton>
        </div>

        <div className="ok__textv2">
          <InteractiveButton
            bkgColorEnabled="none"
            bkgColorHover="#E2DFFD"
            bkgColorFocus="#C6C0FC"
            bkgColorPressed="#C6C0FC"
            customized
            border="1px solid #5B36F2"
            alignItems="center"
            backgroundColor="#FFFFFF"
            padding="9px 4px"
            // margin={isMobile ? '12px 0px 0px 0px' : '0px 0px 0px 0px'}
            borderRadius="4px"
            width="100%"
            onClick={handleClickCancel}
          >
            <Text
              color="#5B36F2"
              fontSize="14px"
              lineHeight="20px"
              fontWeight="700"
              textAlign="center"
            >
              {cancelText}
            </Text>
          </InteractiveButton>
        </div>
      </BlockCommon>
    </Block>
  );
};

ConfirmAction.defaultProps = {
  deliveryMode: '',
  amountDelivery: 0
};

export default ConfirmAction;
